import { z } from 'zod'

export const ZContractId = z.number()

export const ZGuestDepositReturnAccount = z.object({
  depositReturnBankName: z.string().trim().min(1, {
    message: '은행을 선택해 주세요.',
  }),
  depositReturnBankAccount: z.string().trim().min(1, {
    message: '계좌번호를 입력해 주세요.',
  }),
  depositReturnBankHolder: z.string(),
})

export const ZUpdateGuestDepositReturnAccount = z.object({
  contractId: ZContractId,
  body: z.object({
    depositReturnAccount: ZGuestDepositReturnAccount,
  }),
})

export type TGuestDepositReturnAccount = z.infer<
  typeof ZGuestDepositReturnAccount
>

export type TUpdateGuestDepositReturnAccount = z.infer<
  typeof ZUpdateGuestDepositReturnAccount
>
